/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-15 14:57:17
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-15 15:12:01
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/DraggableModules/ContentGroup/ModulesGenerator/ProductGrid.ts
 */
import { ActionType } from 'src/types/common/common';

import {
  //ProductList,
  //   LongCanvas,
  //   Text,
  //   ProductGridDisplay,
  ProductGridDisplay,

  //   ListAdaptor,
} from 'src/constrains/DraggableModules/Components';

const ProductGridDisplayFunctions = ({
  onDynamicChange,
  onStaticChange,
  onModuleTypeChange,
}) => {
  const handleOnProductGridItemReselect = (id, products) => {
    if (onDynamicChange) {
      onDynamicChange({ type: ActionType.reselect, id, data: products });
    }
  };

  const handleOnProductGridItemDelete = (id, index) => {
    if (onDynamicChange) {
      onDynamicChange({ type: ActionType.delete, id, data: { index } });
    }
  };

  const handleOnProductGridItemSort = (id, from, to) => {
    if (onDynamicChange) {
      onDynamicChange({
        type: ActionType.reorder,
        id,
        data: { from, to },
      });
    }
  };

  const handleOnProductGridItemDeleteAll = (id) => {
    if (onDynamicChange) {
      onDynamicChange({
        type: ActionType.deleteAll,
        id,
        data: [],
      });
    }
  };

  const handleOnProductGridStaticChange = (id, data) => {
    if (onStaticChange) {
      onStaticChange({
        type: ActionType.modify,
        id,
        data,
      });
    }
  };
  return {
    handleOnProductGridItemReselect,
    handleOnProductGridItemDelete,
    handleOnProductGridItemSort,
    handleOnProductGridItemDeleteAll,
    handleOnProductGridStaticChange,
    //  handleOnProductGridDisplayModuleTypeChange,
  };
};
const generateProductGridDisplay = ({
  onDynamicChange,
  onStaticChange,
  onModuleTypeChange,
  allDisabled,
}) => {
  const {
    handleOnProductGridItemReselect,
    handleOnProductGridItemDelete,
    handleOnProductGridItemSort,
    handleOnProductGridItemDeleteAll,
    handleOnProductGridStaticChange,
  } = ProductGridDisplayFunctions({
    onDynamicChange,
    onStaticChange,
    onModuleTypeChange,
  });
  return {
    component: ProductGridDisplay,
    props: {
      onItemReselect: handleOnProductGridItemReselect,
      onItemDelete: handleOnProductGridItemDelete,
      onItemSort: handleOnProductGridItemSort,
      onItemDeleteAll: handleOnProductGridItemDeleteAll,
      onStaticChange: handleOnProductGridStaticChange,
      allDisabled,
    },
  };
};
export { generateProductGridDisplay };
